// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3UgT0","buttons":"RemoveExpirationActionButtons_buttons__1kfKR"};